<template>
    <div>
        <b-modal ref="modal" header-class="border-bottom-0" size="xl" no-close-on-backdrop>

            <div class="wrapper">
                <!-- Main content -->

                <!-- title row -->
                <div class="row">
                    <div class="col-12">
                        <h5 class="page-header">
                            <i class="fas fa-globe"></i> {{ nfe.emit_xNome }}
                        </h5>
                    </div>
                </div>
                <br />
                <div class="row">
                    <div class="col-12">
                        <small>Chave:<br />{{ nfe.chNFe }}</small>
                    </div>
                </div>
                <br />

                <div class="row">
                    <div class="col-4">
                        <small><b>Natureza de Operação:</b><br /></small>{{ nfe.natOp }}
                    </div>
                    <div class="col-1">
                        <small><b>Série:</b><br /></small>{{ nfe.serie }}
                    </div>
                    <div class="col-1">
                        <small><b>Modelo:</b><br /></small>{{ nfe.mod }}
                    </div>
                    <div class="col-1">
                        <small><b>Número:</b><br /></small>{{ nfe.nNF }}
                    </div>
                    <div class="col-3">
                        <small><b>Emissão:</b><br /></small>{{ nfe.created_at | dateTimeBr }}
                    </div>
                    <div class="col-1">
                        <!-- <span :class="['badge', 'text-white', status[nfe.status].class]" style="line-height:1.8">{{ status[nfe.status].text }}</span> -->
                        <!-- {{nfe.nProt}} -->
                    </div>
                </div>
                <br />
                <hr />
                <br />

                <template>
                    <div class="row">
                        <div class="col-12">
                            <b>
                                <h5>
                                    <i class="fas fa-user" />
                                    {{ nfe.dest_xNome }}
                                </h5>
                            </b>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <i class="fas fa-address-card" />
                            <template v-if="nfe.dest_CNPJ != null">
                                {{ nfe.dest_CNPJ }} / IE: {{ nfe.dest_IE }}
                            </template>
                            <template v-else>
                                {{ nfe.dest_CPF }} {{ nfe.dest_IE }}
                            </template>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <i class="fas fa-map-marked-alt" />
                            {{ nfe.dest_xLgr }}, {{ nfe.dest_nro }} - {{ nfe.dest_xBairro }} /
                            {{ nfe.dest_xMun }}-{{ nfe.dest_UF }}
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-3">
                            <i class="fas fa-phone" />
                            {{ nfe.dest_fone }}
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-3">
                            <i class="fas fa-envelope" />
                            {{ nfe.dest_fone }}
                        </div>
                    </div>
                </template>
                <br />
                <!-- Table row -->
                <div class="row">
                    <div class="col-12 table-responsive">
                        <table class="table table-striped">
                            <thead>
                                <tr>
                                    <th>Cod</th>
                                    <th>Descrição</th>
                                    <th>Quant.</th>
                                    <th>Valor</th>
                                    <th>CFOP</th>
                                    <th>NCM</th>
                                    <th>CSOSN</th>
                                    <th>Subtotal</th>
                                </tr>
                            </thead>
                            <template v-for="row in nfe.nfe_products">
                                <tbody>
                                    <tr>
                                        <td>{{ row.cprod }}</td>
                                        <td>{{ row.xProd }}</td>
                                        <td>{{ row.qCom }}</td>
                                        <td>{{ row.vProd | decimal }}</td>
                                        <td>{{ row.CFOP }}</td>
                                        <td>{{ row.NCM }}</td>
                                        <td>{{ row.CSOSN }}</td>
                                        <td>{{ row.vProd * row.qCom | decimal }}</td>
                                    </tr>
                                </tbody>
                            </template>
                        </table>
                    </div>
                </div>

                <div class="row">
                    <div class="col-6">
                        <div>
                            <table class="table">
                                <tr>
                                    <th style="width:50%">Total dos Produtos:</th>
                                    <td>{{ nfe.vProd | decimal }}</td>
                                </tr>
                                <tr>
                                    <th>Acréscimo</th>
                                    <td>{{ nfe.vOutro | decimal }}</td>
                                </tr>
                                <tr>
                                    <th>Desconto</th>
                                    <td>{{ nfe.vDesc | decimal }}</td>
                                </tr>
                                <tr>
                                    <th>Frete:</th>
                                    <td>{{ nfe.vFrete | decimal }}</td>
                                </tr>
                                <tr>
                                    <th>Total:</th>
                                    <td>{{ nfe.vNF | decimal }}</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                    <!-- /.col -->
                </div>
                <!-- /.row -->

                <!-- /.content -->
            </div>
            <!-- ./wrapper -->
        </b-modal>
    </div>
</template>

<script>
import Form from "./../../../mixins/Form";
import Filters from "./../../../mixins/Filters";
import ItemNfce from "./../../sections/ItemNfce";
import OrderPayments from "./../../sections/OrderPayments";
import PersonCard from "./../../sections/PersonCard";
import ClientSearch from "./../../ClientSearch";
import VueRouter from "./../../../router";

export default {
    components: {
        ItemNfce,
        OrderPayments,
        PersonCard,
        ClientSearch
    },

    data: function () {
        return {
            form: new Form({

            }),

            status: {
                n: {
                    text: "Não Enviada",
                    class: "badge-secondary",
                    value: "0"
                },

                p: {
                    text: "Processando",
                    class: "badge-info"
                },

                a: {
                    text: "Autorizada",
                    class: "badge-success"
                },

                c: {
                    text: "Cancelada",
                    class: "badge-danger"
                },
                r: {
                    text: "Rejeitada",
                    class: "badge-warning"
                },
                i: {
                    text: "Inutilizada",
                    class: "badge-secondary"
                }
            },

            alertData: {
                isVisible: false,
                message: null
            },

            nfe: {}
        };
    },

    mounted() {
        // axios
        //   .post("../../api/nfe/selectserie")
        //   .then(response => {
        //     this.serieNf = this.getSerieOptions(response.data.series);

        //     this.form.serie.value = response.data.series[0].id

        //     if (response.data.nfNumber.NF == null) {
        //       this.form.number.value = 1
        //     } else {
        //       this.form.number.value = response.data.nfNumber.NF;
        //     }

        //     console.log(response.data);

        //     this.$store.commit("pageHasLoaded");
        //   })
        //   .catch(error => {
        //     this.error = error;
        //   });
    },

    methods: {
        open(id = null) {
            this.edit(id);
        },

        getSerieOptions(data) {
            var options = {};

            for (let index in data) {
                options[data[index].serie] = data[index].serie;
            }

            return options;
        },

        edit(id) {
            axios
                .post('api/nfe/edit/' + id)
                .then(response => {
                    this.nfe = response.data

                    this.$refs.modal.show();
                })
                .catch(error => {
                    this.error = error;
                });

        },

        // store the form
        store() {
            if (this.form.isValid()) {
                this.$store.commit("showLoading");

                axios
                    .post("./../api/nfe/store", this.getAttributes())
                    .then(response => {
                        this.$store.commit("hideLoading");

                        VueRouter.push({
                            path: "/nf-e"
                        });
                    })
                    .catch(error => {
                        this.$store.commit("hideLoading");
                        this.error = error;
                    });
            } else {
                this.alertData.message = this.form.getFirstErrorMsg();

                this.alertData.isVisible = true;
            }
        },

        // prepare the attributes for store
        getAttributes() {
            var attributes = this.form.getValues();

            attributes.products = this.products;

            attributes.payments = this.payments;

            return attributes;
        },

        // remove product from list
        deleteProduct(index) {
            // prevent discount error
            this.form.discount.value = 0;
            this.discountPercent = 0;

            this.$delete(this.products, index);
        },

        // set update state on orderProduct component
        setProductUpdate(index) {
            this.$refs.ItemNfce.setProductUpdate(index);
        },

        // calcs the value or totals when change percent
        calcUpdateValue(field) {
            this.form[field].value =
                Math.round(this.productsTotal * (this[field + "Percent"] / 100) * 100) /
                100;
        },

        // calcs the percent or totals when change value
        calcUpdatePercent(field) {
            if (this.productsTotal != 0) {
                this[field + "Percent"] =
                    (this.form[field].value * 100) / this.productsTotal;
                return;
            }
        }
    }
};
</script>

<style>
.row-list-product {
    padding-top: 1rem;
    padding-bottom: 1rem;
    /*border-top: dashed 1px gray;*/
    border-bottom: dashed 1px rgba(0, 0, 0, 0.125);
}

.row-list-first {
    padding-top: 1rem;
    /*border-top: dashed 1px rgba(0, 0, 0, 0.125);*/
    border-top: dashed 1px rgba(0, 0, 0, 0.125);
}
</style>
